module.exports = function anonymous(it
/**/) {
var out='<div class="plot-wrapper last-parameters span7 offset1"> <div class="row-fluid"> <h2 class="title">Idler spatial distribution after projecting the signal into a Gaussian mode</h2> <div class="btn-wrap "> <button class="btn collapse-ctrl-plot" id="collapse-modesolver">&#x2296;</button> </div> <p> WARNING: This module is under heavy development. Do not trus ANY of the results you obtain from it. </p> </div><div class="signalmode"> <!-- heat map goes here --></div></div>';return out;
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/dot-loader!./browser/library/js/templates/modesolver-layout.tpl
 ** module id = 499
 ** module chunks = 1
 **/